// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"732b901a","879":"b214de85"}[chunkId] + ".chunk.js";
};